
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5H5V7.5H2V4.5ZM2 10.5H5V13.5H2V10.5ZM5 16.5H2V19.5H5V16.5ZM7 4.5H22V7.5H7V4.5ZM22 10.5H7V13.5H14.0313C15.089 12.5665 16.4783 12 18 12C19.5217 12 20.911 12.5665 21.9687 13.5H22V10.5ZM12.189 16.5C12.0656 16.9794 12 17.4821 12 18C12 18.5179 12.0656 19.0206 12.189 19.5H7V16.5H12.189Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15 15.8034C15 14.9934 16.56 14.6034 18 14.6034C19.44 14.6034 21 14.9934 21 15.8034C21 16.6134 19.44 17.0034 18 17.0034C16.56 17.0034 15 16.6134 15 15.8034ZM18 17.6034C16.86 17.6034 15.69 17.3934 15 16.8834V18.2034C15 19.0134 16.56 19.4034 18 19.4034C19.44 19.4034 21 19.0134 21 18.2034V16.8834C20.31 17.3934 19.14 17.6034 18 17.6034ZM18 20.0034C16.86 20.0034 15.69 19.7934 15 19.2834V20.6034C15 21.4134 16.56 21.8034 18 21.8034C19.44 21.8034 21 21.4134 21 20.6034V19.2834C20.31 19.7934 19.14 20.0034 18 20.0034Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowNavigationDataFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
